module.exports = function() {
  return new Worker(__webpack_public_path__ + "7de998473b01042d8232.worker.js");
};